import React from 'react'
import CommentItem from './CommentItem'
import Loading from 'components/Loading'
import SnackBar from 'components/SnackBar'
import utils from 'Utils'
import 'style/Comments.css'

const loadingStyle = {
    margin: 'auto',
    background: 'rgba(255, 255, 255, 0)',
    display: 'block',
    width: 25,
    height: 25
}

class Comments extends React.Component {
    state = {
        loading: false,
        comments: [],
        page: 0,
        pages: 0
    }

    componentDidMount() {
        this.getComments()
    }

    getComments = async (getMore = false) => {
        if (getMore) this.setState({ loading: true })

        const res = await utils.iaxios({
            method: 'get',
            url: utils.urls.getComments(this.props.doctorId) + `?page=${this.state.page}`,
        }, true)
            .catch((e) => {
                console.log(e.response)
                let message = (e.response && e.response.data && e.response.data.message) || 'خطایی رخ داده است'
                this.SnackBar.openSnackbar(message)
            })

        if (!res) return
        if (!res.data.success) return this.SnackBar.openSnackbar('خطایی رخ داده است')

        let state = {}

        if (getMore) state = { ...state, loading: false }

        state = {
            ...state,
            comments: [...this.state.comments, ...res.data.comments],
            pages: Math.ceil(res.data.count / 20)
        }

        this.setState(state)
    }

    getMoreComments = async () => {
        await this.setState({ page: this.state.page + 1 })
        this.getComments(true)
    }

    render() {
        return (
            <div className="card comments">
                <SnackBar ref={el => this.SnackBar = el} />
                <div className="card-title">
                    <div className="card-indicator"></div>
                    نظرات
                </div>
                {this.state.comments.length > 0 ?
                    <>
                        <div>
                            {this.state.comments.map(comment => <CommentItem key={comment.id} comment={comment} />)}
                        </div>
                        <div className="comments__more-button">
                            {this.state.loading ?
                                <Loading style={loadingStyle} /> :
                                this.state.page < this.state.pages - 1 && <button onClick={this.getMoreComments}>نظرات بیشتر</button>
                            }
                        </div>
                    </> :
                    <div className="no-comment">نظری ثبت نشده است</div>
                }
            </div>
        )
    }
}

export default Comments